import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CathyService } from '@sbd-doug-frontend/app/services/cathy.service';

@Component({
  selector: 'cipx-file-upload',
  templateUrl: 'file-upload.component.html',
  standalone: false,
})


export class FileUploadComponent implements OnInit{
  private _cathyService = inject(CathyService);
  fileUrl!: string | null;
  uploadFile!: File | null;

  @Input() acceptedFileMimeTypes: string[] = [];
  @Input() currentConfig: FileUploadConfig = <FileUploadConfig>{caption:'', horizontal:true, noIcon: true, noButton: true};
  @Output() fileUploadChanged = new EventEmitter<File[]>();
  @Input() resetForm = false;
  @Input() isUploading = false;


  defaultConfig = <FileUploadConfig>({
    caption: `Drag and drop <br /> file here to upload.`,
    noIcon: false,
    horizontal: false,
    noButton: false,
  });
  @Input() multiple: boolean = false;

  handleChange(event: any) {
    //I am letting the server handle the file size validation.
    /*const files = Array.from(event.target.files) as File[];
    const maxFileSize = 50 * 1024 * 1024; // 50MB

    for (const file of files) {
      if (file.size > maxFileSize) {
        this._cathyService.error(`File "${file.name}" is too large. Max size allowed is 50MB.`);
        // Reset the input
        event.target.value = '';
        this.currentConfig.caption = this.defaultConfig.caption || '';
        return;
      }
    }
*/

    // const file = event.target.files[0] as File;
    // this.fileUrl = URL.createObjectURL(file);
    // this.uploadFile = file;
    const files = event.target.files as File[];

    if (files.length > 0) {
      this.currentConfig.caption = `(${files.length}) File selected`;
      let fnames = '';
      //array methods are not supported
      for (const file of files) {
        fnames+= file.name + ', ';
      }

      this.currentConfig.caption += '<br>' +fnames;
    }
    this.fileUploadChanged.emit(files);
  }

  ngOnInit() {
    //console.log('reset', this.resetForm);
  }

}
export interface FileUploadConfig {
  caption?: string;
  noButton?: boolean;
  horizontal?: boolean;
  noIcon?: boolean;
}
